import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  pageInfo : any = {
    pageTitle:'Liên hệ với chúng tôi',
    pageSubTitle:'Vũ Khánh Coffee & Bakery'
  }


  constructor() { }

  ngOnInit(): void {
  }

}
